$(document).ready(function(){
  $('.p-front-slick').slick({
    centerMode: true,
    centerPadding: '33%',
    slidesToShow: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          centerMode: true,
          centerPadding: '8%',
          slidesToShow: 1,
        }
      }
    ]
  });

  // max-width: 767px のときのみ #checkout-area の表示状態に応じて .move-to-checkout を切り替え
  var checkoutArea = document.querySelector('#checkout-area');
  var moveToCheckout = document.querySelectorAll('.move-to-checkout');
  var checkoutObserver = null;
  var mobileMq = window.matchMedia('(max-width: 767px)');

  // checkout-area が画面内なら非表示、画面外なら表示
  function setMoveToCheckoutDisplay(isVisible) {
    moveToCheckout.forEach(function(el) {
      el.style.display = isVisible ? 'none' : 'block';
    });
  }

  // デスクトップ時はインライン指定を解除し、CSSの制御に戻す
  function clearMoveToCheckoutDisplay() {
    moveToCheckout.forEach(function(el) {
      el.style.display = '';
    });
  }

  // IntersectionObserver のセットアップ／破棄
  function setupCheckoutObserver() {
    if (!checkoutArea || !moveToCheckout.length) return;

    // 既存の監視があれば解除
    if (checkoutObserver) {
      checkoutObserver.disconnect();
      checkoutObserver = null;
    }

    // モバイル以外では監視しない
    if (!mobileMq.matches) {
      clearMoveToCheckoutDisplay();
      return;
    }

    // #checkout-area の画面内出入を監視
    checkoutObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        setMoveToCheckoutDisplay(entry.isIntersecting);
      });
    });

    checkoutObserver.observe(checkoutArea);
  }

  setupCheckoutObserver();
  // 画面幅の変更時にも再セットアップ（古いブラウザ向けに addListener も用意）
  if (mobileMq.addEventListener) {
    mobileMq.addEventListener('change', setupCheckoutObserver);
  } else {
    mobileMq.addListener(setupCheckoutObserver);
  }

  // .move-to-checkout a クリックでページ内リンクへスムーススクロール
  $(document).on('click', '.move-to-checkout a[href^="#"]', function(e) {
    var targetId = this.getAttribute('href');
    if (!targetId || targetId === '#') return;

    var $target = $(targetId);
    if (!$target.length) return;

    e.preventDefault();
    $('html, body').animate({
      scrollTop: $target.offset().top
    }, 500);
  });
});
